import Fondo from "../assets/washQ.svg"
import { motion } from "framer-motion";

const QuienesSomos = () => {
    return (
        <div className="w-full h-auto md:h-[44vh] grid grid-cols-1 md:grid-cols-2 md:px-36 py-6">
            <motion.div
                className="w-full h-full flex flex-col justify-center text-center px-4 md:px-10 gap-4 text-sky-800 "
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <h1 className="font-bold text-2xl">¡Bienvenido!</h1>
                <p className="text-justify">
                    Somos una empresa que ofrece servicios a empresas, hoteles, fábricas, restaurantes,
                    salones de eventos y público en general.
                    <br/>
                    Lavamos todo tipo de telas, uniformes y protectores,
                    distinguiéndonos de nuestra competencia por la eficiencia y calidad con la que trabajamos.
                </p>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }}
            />
        </div>
    );
};
export default QuienesSomos;